import {selfTqo} from "../rpc/webrpc-client.gen.ts";
import {useInfallibleQuery} from "../util/useInfallibleQuery.tsx";
import {AgentPreferences, defaultPrefs, LiveTieredColor} from "../util/defaultPrefs.tsx";
import {defaultInspectorPrefs} from "../inspector/defaultInspectorPrefs.tsx";
import {defaultSupervisorPrefs} from "../supervise/defaultSupervisorPrefs.tsx";
import {defaultDriverPrefs} from "../driver/defaultDriverPrefs.tsx";
import {defaultDispatcherPrefs} from "../dispatch/defaultDispatcherPrefs.tsx";
import {InspectionStageOrSurcharge} from "../inspect/stages.tsx";
import {useMothership} from "../tq/tqx.tsx";

export function usePreferences() {
    const mama = useMothership();
    return useInfallibleQuery({
        ...selfTqo(mama), select: (rpcfull => {
            const full = rpcfull.srv
            const zprv = AgentPreferences.safeParse(full.prefs);
            let rv = zprv.success ? zprv.data : defaultPrefs;

            if (full.self.inspectorFor) {
                rv = {...defaultInspectorPrefs, ...rv};
            }
            if (full.self.supervisorFor) {
                rv = {...defaultSupervisorPrefs, ...rv};
            }
            if (full.self.canDrive) {
                rv = {...defaultDriverPrefs, ...rv};
            }
            if (full.self.canDispatch) {
                rv = {...defaultDispatcherPrefs, ...rv};
            }
            // if (full.self.supervisorFor) {
            // }

            return rv;
        }),
    });
}

export type InspectionTierColorMap = Map<InspectionStageOrSurcharge, LiveTieredColor<InspectionStageOrSurcharge>>;

// export function useInspectionTierColorMap(): InfallibleUseResult<InspectionTierColorMap> {
//     const prefsTqrv = usePreferences();
//     const rv = useMemo(() => {
//         if (prefsTqrv.isPending) {
//             return pendingUseResult;
//         }
//         const iscEntries = prefsTqrv.data.inspectionTierColors ?? [];
//         const ixen = indexesOf(iscEntries);
//
//         const rv = new Map<InspectionStageOrSurchange, LiveTieredColor<InspectionStageOrSurchange>>();
//         for (const ix of ixen) {
//             const frozenEntry = iscEntries[ix];
//             if (frozenEntry) {
//                 const liveEntry: Omit<LiveTieredColor<InspectionStageOrSurchange>, "toggleWatched"> & {
//                     toggleWatched?: LiveTieredColor<InspectionStageOrSurchange>["toggleWatched"]
//                 } = {...frozenEntry, sortIndex: ix + 1};
//                 liveEntry.toggleWatched = () => {
//                     const prev = rv.get(liveEntry.tier);
//                     if (prev) {
//                         const next = {...prev, watched: !prev.watched};
//                         rv.set(liveEntry.tier, next);
//                     }
//                 };
//                 rv.set(liveEntry.tier, liveEntry as LiveTieredColor<InspectionStage>);
//             }
//         }
//
//         return successUseResult(rv);
//     }, [prefsTqrv.data?.inspectionTierColors, prefsTqrv.isPending]);
//
//     return rv;
// }


